module.exports = __webpack_public_path__ + "img/go-detail.5768ce0f.png";